/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_2_LInputs */

const en_mk_proof_2_l = /** @type {(inputs: Mk_Proof_2_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no installation needed to start working`)
};

const id_mk_proof_2_l = /** @type {(inputs: Mk_Proof_2_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`langsung bekerja tanpa memasang aplikasi`)
};

/**
* | output |
* | --- |
* | "no installation needed to start working" |
*
* @param {Mk_Proof_2_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_2_l = /** @type {((inputs?: Mk_Proof_2_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_2_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_2_l(inputs)
	return en_mk_proof_2_l(inputs)
});